import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiError, apiFetch } from 'API/apiClient';
import type { IWorkflowHistory } from 'types/IWorkflow';
import type { RootState } from 'store/store';

export const submitDrawing = createAsyncThunk<void, { drawingId: number; comment?: string }, { rejectValue: ApiError; state: RootState }>('workflow/submit', async ({ drawingId, comment }, { rejectWithValue }) => {
  return await apiFetch<void>(`/drawing/${drawingId}/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ comment }),
  }, rejectWithValue);
});

export const approveDrawing = createAsyncThunk<void, { drawingId: number; comment?: string }, { rejectValue: ApiError; state: RootState }>('workflow/approve', async ({ drawingId, comment }, { rejectWithValue }) => {
  return await apiFetch<void>(`/drawing/${drawingId}/approve`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ comment }),
  }, rejectWithValue);
});

export const rejectDrawing = createAsyncThunk<void, { drawingId: number; reason: string }, { rejectValue: ApiError; state: RootState }>('workflow/reject', async ({ drawingId, reason }, { rejectWithValue }) => {
  return await apiFetch<void>(`/drawing/${drawingId}/reject`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reason }),
  }, rejectWithValue);
});

export const resetApproval = createAsyncThunk<void, { drawingId: number; reason: string }, { rejectValue: ApiError; state: RootState }>('workflow/resetApproval', async ({ drawingId, reason }, { rejectWithValue }) => {
  return await apiFetch<void>(`/drawing/${drawingId}/reset-approval`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reason }),
  }, rejectWithValue);
});

export const fetchWorkflowHistory = createAsyncThunk<IWorkflowHistory[], number, { rejectValue: ApiError; state: RootState }>('workflow/fetchHistory', async (drawingId, { rejectWithValue }) => {
  return await apiFetch<IWorkflowHistory[]>(`/workflow/history/${drawingId}`, {}, rejectWithValue);
});
